import { VIEW_TYPES } from "@/other/constants/OtherKeys.jsx";
import type { MarketingStackStep } from "./constants";

export type MarketingStackStepOverride = {
  props?: Record<string, unknown>;
  onClick?: () => void;
  subtitle?: string | null;
  onShowGuide?: () => void;
};

export function resolveContextStepSubtitle(
  override: MarketingStackStepOverride | undefined,
  contextLabel: string | null | undefined,
  activeBoardContextLabel: string | null,
): string | null {
  return override?.subtitle ?? contextLabel ?? activeBoardContextLabel ?? null;
}

export function resolveStepSubtitle(
  step: MarketingStackStep,
  override: MarketingStackStepOverride | undefined,
  contextLabel: string | null | undefined,
  activeBoardContextLabel: string | null,
): string | null {
  if (step.viewType !== VIEW_TYPES.context) {
    return override?.subtitle ?? null;
  }
  return resolveContextStepSubtitle(override, contextLabel, activeBoardContextLabel);
}

export function stepAccessibleLabel(step: MarketingStackStep, subtitle: string | null): string {
  return subtitle ? `${step.label}, ${subtitle}` : step.label;
}

export function buildContextNavigationParams(
  step: MarketingStackStep,
  activeContextId: number | null | undefined,
): Record<string, unknown> {
  if (step.viewType === VIEW_TYPES.context && activeContextId != null) {
    return { contextId: activeContextId };
  }
  return {};
}
